import { useState, Fragment, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Alert,
  Button,
  FormGroup,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  NotificationManager,
  Spinner,
  Toggle,
} from "design-react-kit";

import secureLocalStorage from "react-secure-storage";
import { notifyUser } from "../../services/helpers";

const MunicipalityConfigurationModal = ({ modalOpen, modalCloseHandler }) => {
  const [twoFactorAuthStatus, setTwoFactorAuthStatus] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen) {
      const selectedClient = secureLocalStorage.getItem("selectedClient");
      setTwoFactorAuthStatus(selectedClient.twoFactorEnabled);
    }
  }, [modalOpen]);

  const setTwoFactorAuthHandler = () => {
    setIsLoading(true);
    sendApiRequest(
      `Municipality/SetTwoFactorAuth`,
      "POST",
      true,
      {
        fiscalCode: userContext.selectedClientFiscalCode,
        twoFactorEnabled: twoFactorAuthStatus,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          const selectedClient = secureLocalStorage.getItem("selectedClient");
          selectedClient.twoFactorEnabled = twoFactorAuthStatus;
          secureLocalStorage.setItem("selectedClient", selectedClient);
          userContext.setSelectedClientTwoFactorEnabled(twoFactorAuthStatus);
          const message = twoFactorAuthStatus
            ? "Autenticazione a due fattori abilitata completata con successo!"
            : "Autenticazione a due fattori disabilitata completata con successo!";
          notifyUser(message, "success", "it-check", 5000);
          setIsLoading(false);
          setTimeout(() => {
            modalCloseHandler();
          }, 3000);
        }
      }
    });
  };

  return (
    <Fragment>
      <Modal
        isOpen={modalOpen}
        labelledBy="configureMunicipality"
        toggle={modalCloseHandler}
      >
        <ModalHeader id="configureMunicipality" toggle={modalCloseHandler}>
          <h5>Configura ente</h5>
          <p>{userContext.selectedClientName}</p>
        </ModalHeader>
        <ModalBody>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mb-5">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          <FormGroup
            check
            className="form-check-group d-flex align-items-center justify-content-start save"
          >
            <Toggle
              id="setTwoFactorEnabled"
              checked={twoFactorAuthStatus}
              onChange={(e) => {
                setTwoFactorAuthStatus(e.target.checked);
              }}
            />
            <span className="mb-2">Autenticazione a due fattori</span>
          </FormGroup>
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
          <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
            <Button
              style={{
                backgroundColor: "#5EB423",
                color: "#fff",
                padding: "7px 15px",
              }}
              id="setTwoFactorEnabledButton"
              onClick={(e) => setTwoFactorAuthHandler()}
            >
              <Icon icon="it-check" fill="#ffffff" /> Conferma
            </Button>
          </div>
        </ModalBody>
        <div>
          <NotificationManager
            containerId="twoFactorEnabled"
            fix="right"
            closeOnClick={true}
            state="success"
            duration={30000}
          />
        </div>
      </Modal>
    </Fragment>
  );
};

export default MunicipalityConfigurationModal;
